import { useSelector } from 'react-redux';
import { FC } from 'react';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { selectBedroomsFilter } from 'shared/selectors/filters';
import { useBedroomsChangeHandler } from './hooks';
import { FILTER_KEY } from './constants';
import { DropdownBedrooms, DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const BedroomsContainer: FC = () => {
  const {
    label,
    value: { min, max },
  } = useSelector(selectBedroomsFilter);

  const { onMaxChange, onMinChange } = useBedroomsChangeHandler();

  const dropdownState = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      {...dropdownState}
      showTooltip={showTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <DropdownBedrooms valueMin={min} valueMax={max} onMaxChange={onMaxChange} onMinChange={onMinChange} />
      }
    />
  );
};
